function setViewResolver(component) {
    return require('../views/' + component).default;
}

const layout = {
    render(h) {
        return h('router-view')
    }
}

export default [
    {
        path: '/',
        component: setViewResolver('Home'),
        name: 'Home',
        meta: {name: 'Home', title: '홈', transitionName: 'none'},
    },
    {
        path: '/intro',
        component: setViewResolver('intro/Intro'),
        name: 'Intro',
        meta: {name: 'Intro', title: '함께하는아버지들?', transitionName: 'none'}
    },
    {
        path: '/business/:wr_id',
        component: setViewResolver('business/BusinessDetail'),
        name: 'BusinessDetail',
        meta: {name: 'BusinessDetail', title: '주요사업 상세', transitionName: 'none'}
    },
    {
        path: '/financial/:wr_id',
        component: setViewResolver('financial/FinancialDetail'),
        name: 'FinancialDetail',
        meta: {name: 'FinancialDetail', title: '재무보고 상세', transitionName: 'none'}
    },
    {
        path: '/news',
        component: setViewResolver('news/News'),
        name: 'News',
        meta: {name: 'News', title: '뉴스', transitionName: 'none'}
    },
    {
        path: '/news/:wr_id',
        component: setViewResolver('news/NewsDetail'),
        name: 'NewsDetail',
        meta: {name: 'NewsDetail', title: '뉴스 상세', transitionName: 'none'}
    },
    {
        path: '/donate',
        component: setViewResolver('donate/Donate'),
        name: 'Donate',
        meta: {name: 'Donate', title: '나눔&배움', transitionName: 'none',}
    },
    {
        path: '/donate/prime/:wr_id',
        component: setViewResolver('donate/DonatePrimeDetail'),
        name: 'DonatePrimeDetail',
        meta: {name: 'DonatePrimeDetail', title: '나눔&배움 상세', transitionName: 'none',}
    },
    {
        path: '/donate/:wr_id',
        component: setViewResolver('donate/DonateDetail'),
        name: 'DonateDetail',
        meta: {name: 'DonateDetail', title: '나눔&배움 상세', transitionName: 'none',}
    },
    {
        path: '/album',
        component: setViewResolver('album/Album'),
        name: 'Album',
        meta: {name: 'Album', title: '앨범', transitionName: 'none',}
    },
    {
        path: '/album/:wr_id',
        component: setViewResolver('album/AlbumDetail'),
        name: 'AlbumDetail',
        meta: {name: 'AlbumDetail', title: '앨범 상세', transitionName: 'none',}
    },
    {
        path: '/search',
        component: setViewResolver('search/Search'),
        name: 'Search',
        meta: {name: 'Search', title: '검색', transitionName: 'none',}
    },
    {
        path: '/term',
        component: setViewResolver('term/Term'),
        name: 'Term',
        meta: {name: 'Term', title: '사용자이용약관', transitionName: 'none',}
    },
    {
        path: '/privacy',
        component: setViewResolver('term/Privacy'),
        name: 'Privacy',
        meta: {name: 'Privacy', title: '개인정보처리약관', transitionName: 'none',}
    },
    {
        path: '/amidan',
        component: setViewResolver('amidan/Amidan'),
        name: 'Amidan',
        meta: {name: 'Amidan', title: '아미단', transitionName: 'none',}
    },
    {
        path: '/popup/:p_idx',
        component: setViewResolver('popup/PopupDetail'),
        name: 'PopupDetail',
        meta: {name: 'PopupDetail', title: '팝업 상세', transitionName: 'none',}
    },

]